module.exports = __webpack_public_path__ + "static/media/facial.2acdbe68.jpg";